import script from "./AdminScoringResultView.vue?vue&type=script&setup=true&lang=ts"
export * from "./AdminScoringResultView.vue?vue&type=script&setup=true&lang=ts"

const __exports__ = script;

export default __exports__